<avi-confirmation
    (onClose)="handleCancel()"
    headerText="{{ l10nKeys.headerMessage | vtranslate }}"
    class="avi-suppress-warnings-dialog sel-avi-suppress-warnings-dialog"
>
    <ng-container ngProjectAs="avi-confirmation_modal-content">
        <div>{{ l10nKeys.subHeaderMessage | vtranslate }}</div>
        <avi-alert-group
            [alerts]="warningList"
            class="avi-suppress-warnings-dialog__alert-group"
        ></avi-alert-group>
        <clr-checkbox-container>
            <clr-checkbox-wrapper>
                <input
                    clrCheckbox
                    name="suppress-warnings"
                    id="suppress-warnings"
                    type="checkbox"
                    [(ngModel)]="suppressWarnings"
                />
                <label>{{ l10nKeys.suppressWarningsLabel | vtranslate }}</label>
            </clr-checkbox-wrapper>
        </clr-checkbox-container>
        <cds-alert [clrAlertLightweight]="true">
            <span 
                [innerHTML]="footerTextHTML" 
                class="avi-suppress-warnings-dialog__footer"
            ></span>
        </cds-alert>
    </ng-container>

    <ng-container ngProjectAs="avi-confirmation_modal-actions">
        <cds-button
            action="outline"
            (click)="handleCancel()"
        >
            {{ globalL10nKeys.cancelLabel | vtranslate }}
        </cds-button>

        <cds-button
            id="continue-button"
            (click)="handleConfirm()"
            status="primary"
            [disabled]="!suppressWarnings"
        >
            {{ l10nKeys.continueBtnLabel | vtranslate }}
        </cds-button>
    </ng-container>
</avi-confirmation>
